import { useTranslation } from 'react-i18next';
import BasicModal from '@ui-parts/BasicModal';
import Button from '@ui-elements/Button';
import { ButtonProps, Typography } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import styled from 'styled-components';
import { PALETTE } from '~/assets/styles/base';

const ModalHeader = styled.div`
  display: flex;
  margin-top: 32px;
  margin-left: 18px;
  margin-bottom: 32px;
`;

const DeleteInfo = styled.div`
  padding: 32px;
`;

const DeleteNote = styled(Typography)`
  font-size: 18px;
  color: ${PALETTE.text.area};
  margin-bottom: 11px;
`;

type Props = {
  open: boolean;
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  confirmDelete: ButtonProps['onClick'];
  deleteContent: string;
};

const DeleteOriginalFormContentModal: React.FC<Props & ButtonProps> = ({
  open,
  handleClose,
  confirmDelete,
  deleteContent,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const deleteNote1 = t('registration.originalForm.manual.deleteModal.questionNote1', {
    deleteContent,
  });

  const deleteNote2 =
    deleteContent === '改ページ'
      ? t('registration.originalForm.manual.deleteModal.pageNote2')
      : t('registration.originalForm.manual.deleteModal.questionNote2');

  const customModalTitle = (
    <ModalHeader key="deleteModalTitle" data-testid="deleteModalTitle">
      <DeleteOutlineOutlinedIcon
        sx={{ fontSize: '20px', marginTop: '6px', color: PALETTE.text.sub }}
      />
      <Typography
        sx={{
          fontWeight: 'medium',
          fontSize: '20px',
          marginLeft: '14px',
          color: PALETTE.text.area,
        }}
      >
        {t('registration.originalForm.manual.deleteModal.title')}
      </Typography>
    </ModalHeader>
  );

  return (
    <BasicModal
      open={open}
      titleProps={{
        customModalTitle,
      }}
      handleClose={handleClose}
      buttons={[
        <div key="ModalFooterInner">
          <Button
            onClick={confirmDelete}
            colorType="red"
            width="150px"
            dataTestId="deleteQuestionModalButton"
            variant="contained"
          >
            {t('registration.originalForm.manual.deleteModal.title')}
          </Button>
        </div>,
      ]}
      dataTestId="deleteModal"
      width="526px"
    >
      <DeleteInfo>
        <DeleteNote data-testid="deleteModalNote">{deleteNote1}</DeleteNote>
        <DeleteNote data-testid="deleteModalNote">{deleteNote2}</DeleteNote>
      </DeleteInfo>
    </BasicModal>
  );
};

export default DeleteOriginalFormContentModal;
